import { combineReducers } from "@reduxjs/toolkit"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import bookingReducer from "./slices/booking_management_slice"
import externalReducer from "./slices/external_management_slice"
import FleetReducer from "./slices/fleet_management_slice"
import priceReducer from "./slices/price_list_management_slice"
import userManagementReducer from "./slices/user_management_slice"
const rootReducer = combineReducers({
  userMngmt: userManagementReducer,
  fleet: FleetReducer,
  booking: bookingReducer,
  price: priceReducer,
  external: externalReducer
})

const persistConfig = {
  key: "root",
  storage
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const kaleAppReducer = (state, action) => {
  switch (action.type) {
    case "LOGOUT":
      state = undefined
      storage.removeItem("persist:root")
      localStorage.removeItem("token")
      break
    case "persist/PERSIST":
    case "persist/REHYDRATE":
    case "@@INIT":
      break
    default:
  }
  return persistedReducer(state, action)
}

export default kaleAppReducer
